import { ExpandMoreOutlined } from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
} from '@mui/material';
import { Rule } from 'api/ml-service/ml-service.types';
import CustomRuleDetails from './custom-rule-details/custom-rule-details.component';
import CustomRuleSummary from './custom-rule-summary/custom-rule-summary.component';
import CustomRuleActions from './custom-rule-actions/custom-rule-actions.component';

type CustomRuleProps = {
  rule: Rule;
};

const CustomRule = ({ rule }: CustomRuleProps) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
        <CustomRuleSummary rule={rule} />
      </AccordionSummary>
      <AccordionDetails>
        <CustomRuleDetails rule={rule} />
      </AccordionDetails>
      <AccordionActions>
        <CustomRuleActions ruleId={rule.ruleId} />
      </AccordionActions>
    </Accordion>
  );
};

export default CustomRule;
